export const HOME = "/";
export const PET = "/pet/:id";
export const NOT_FOUND = "*";